/**
 * Comutatorul codului QR descarcabil pe linkurile de colaborator (SE-36, ascuns 2026-09-17).
 *
 * Decizie client 17.09: colaboratorul ramane pe LINK, nu cod QR — dar codul nu se arunca (decizie
 * owner, aceeasi seara), doar se ascunde. `esteColaboratorQrActiv` e o functie PURA, testabila,
 * spre deosebire de restul flag-urilor `VITE_*` (citite direct, netestate individual): asa capata
 * un test real pornit/oprit, nu doar o citire de mediu presupusa corecta.
 *
 * OPRIT implicit, si citit o singura data, in `VITE_COLABORATOR_QR_ACTIVA` de mai jos — acelasi
 * motiv ca restul flag-urilor: Vite inlocuieste TEXTUAL `import.meta.env.VITE_...` la build, deci
 * numele variabilei apare o SINGURA data in cod.
 */
export function esteColaboratorQrActiv(valoare: string | undefined): boolean {
    return String(valoare ?? '').toLowerCase() === 'true';
}

export const VITE_COLABORATOR_QR_ACTIVA = esteColaboratorQrActiv(import.meta.env.VITE_COLABORATOR_QR);
